import i18n from "@/i18n"

/**
 * This is an object of standard pagination settings
 * for the entire project.
 */

const setPaginationSize = (key, pageSize = 10) => {
  return new Promise((resolve, reject) => {
    const nameStorage = `limit-${key}`

    try {
      const paginationSize = localStorage.getItem(nameStorage)

      if (!paginationSize || +paginationSize !== pageSize) {
        localStorage.setItem(nameStorage, pageSize.toString())
      }

      resolve(true)
    } catch (e) {
      resolve(false)
    }
  })
}

const defaultData = {
  // pageSize: 10,
  pageSize: 1,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "50", "100"],
  showTotal: (total, range) =>
    `${range[0]}-${range[1]} ${i18n.t("pagination.of")} ${total} ${i18n.t("pagination.items")}`
}

const getPageSize = (key) => {
  let pageSize = 10

  if (key) {
    const value = localStorage.getItem(`limit-${key}`)

    if (value) {
      pageSize = +value
    }
  }

  return pageSize
}

const getPaginationConfig = (key, position = "bottom") => {
  return {
    ...defaultData,
    pageSize: getPageSize(key),
    position
  }
}

export default {
  getPageSize,
  getDefault: (key) => getPaginationConfig(key),
  default: getPaginationConfig(),
  drafts: getPaginationConfig("drafts", "both"),
  setPaginationSize
}
